import Tone from 'tone';
import Effects from 'effects/Effects.js';
import {AbstractParameter} from 'parameters/AbstractParameter.js';

class EQ3 extends Effects.Effect {
    constructor(sequencerEngine) {
        super('EQ 3', () => new Tone.EQ3(), sequencerEngine);

        this.lowParameter = new AbstractParameter(
            'Low', this.effectNode.low, (o, x) => o.value = x,
            {
                min: -10,
                max: 10,
                unit: 'db',
                defaultValue: 0
            });
        this.lowFrequencyParameter = new AbstractParameter(
            'Low Frequency', this.effectNode.lowFrequency, (o, x) => o.value = x,
            {
                min: 0,
                max: 400,
                unit: 'hz',
                defaultValue: 0
            });
        this.midParameter = new AbstractParameter(
            'Mid', this.effectNode.mid, (o, x) => o.value = x,
            {
                min: -10,
                max: 10,
                unit: 'db',
                defaultValue: 0
            });
        this.highParameter = new AbstractParameter(
            'High', this.effectNode.high, (o, x) => o.value = x,
            {
                min: -10,
                max: 10,
                unit: 'db',
                defaultValue: 0
            });
        this.highFrequencyParameter = new AbstractParameter(
            'High Frequency', this.effectNode.highFrequency, (o, x) => o.value = x,
            {
                min: 1000,
                max: 10000,
                unit: 'hz',
                defaultValue: 2000
            });

        this.registerParameter(this.lowParameter);
        this.registerParameter(this.midParameter);
        this.registerParameter(this.highParameter);
        this.registerParameter(this.lowFrequencyParameter);
        this.registerParameter(this.highFrequencyParameter);
    }

    getJson() {
        let json = {
            ... super.getJson(),
            low: this.lowParameter.get(),
            mid: this.midParameter.get(),
            high: this.highParameter.get(),
            lowFrequency: this.lowFrequencyParameter.get(),
            highFrequency: this.highFrequencyParameter.get(),
            enabled: this.enabledParameter.get(),
            name: this.name
        };
        return json;
    }

    fromJson(json, isCopy) {
        super.fromJson(json, isCopy);
        this.lowParameter.set(json.low);
        this.midParameter.set(json.mid);
        this.highParameter.set(json.high);
        this.lowFrequencyParameter.set(json.lowFrequency);
        this.highFrequencyParameter.set(json.highFrequency);
        this.enable(json.enabled);
    }

    getEffectCopy(sequencerEngine=this.sequencerEngine, ignoreId=true) {
        var copy = new EQ3(sequencerEngine);
        copy.fromJson(this.getJson(), ignoreId);
        return copy;
    }
}

export default EQ3;
